import { useRef, RefObject } from "react";
import { useVideoConfig, OffthreadVideo, Audio } from "remotion";
import { VideoSegmentMultiFocusDesignSystemConfig } from "../../VideoSegmentMultiFocus";
import { onVideoFrame } from "../DefaultVideoSegmentMultiFocus";
import { BorderWrapper } from "../utils/borderStyle";
import { getCloudFrontUrl } from "../../../../../../helper/CloudFrontUrlHelper";

const PortraitFocus: React.FC<VideoSegmentMultiFocusDesignSystemConfig> = ({ startTimestampMS, endTimestampMS, videoURL, spacing, borderRadius, border, borderStyle, framing, designSystem, audioURL }) => {
    const { width, height, fps } = useVideoConfig();
    const resolvedVideoURL = getCloudFrontUrl(videoURL);
    const resolvedAudioURL = audioURL ? getCloudFrontUrl(audioURL) : undefined;

    // We will display a single 9:16 video
    const canvasRefs = [useRef<HTMLCanvasElement>(null)];

    const paddingSize = spacing ? Math.sqrt(width * height) * 0.05 : 0;
    const borderThickness = spacing ? Math.sqrt(width * height) / 150 : 0;

    const totalHeight = (height - paddingSize * 2 - borderThickness * 2);
    const totalWidth = totalHeight * 9 / 16;

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-evenly',
                alignContent: 'space-evenly',
                width: '100%',
                height: '100%',
            }}
        >
            <OffthreadVideo
                style={{ opacity: 0, display: 'none' }}
                src={resolvedVideoURL}
                startFrom={startTimestampMS / 1000 * fps}
                endAt={endTimestampMS / 1000 * fps}
                onVideoFrame={(frame) => onVideoFrame(frame, framing[designSystem.canvas.aspectRatio].focusRegions, canvasRefs as RefObject<HTMLCanvasElement>[])}
                muted={Boolean(resolvedAudioURL)}
            />
            {resolvedAudioURL && <Audio src={resolvedAudioURL} />}
            {framing[designSystem.canvas.aspectRatio].focusRegions.map((_, index) => (
                <BorderWrapper
                    key={index}
                    borderStyle={borderStyle}
                    borderThickness={borderThickness}
                    borderRadius={borderRadius}
                >
                    <canvas
                        ref={canvasRefs[index]}
                        width={totalWidth}
                        height={totalHeight}
                        style={{
                            aspectRatio: '9 / 16',
                        }}
                    />
                </BorderWrapper>
            ))}
        </div>
    );
}

export const PortraitFocusVideoSegment: React.FC<VideoSegmentMultiFocusDesignSystemConfig> = (props) => {
    return (
        <PortraitFocus {...props} />
    )
}
